import * as bootstrap from 'bootstrap';
import accessibility from '../assets/accessibility.svg';
import { useEffect } from 'react';

export default function AccessibilityFlyout({ info }) {
    useEffect(() => {
        const tooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        tooltips.forEach(e => new bootstrap.Tooltip(e));
    }, []);

    return (
        <a href="/" data-bs-toggle="tooltip" data-bs-title={info}>
            <img src={accessibility} alt='accessibility info icon'></img>
        </a> 
    );
}